// Initial State
const initialState = {
  pharmacy: null,
  csvExists: false,
  massInviteStats: null,
  error: null,
  isLoading: false,
  pendingMassInviteId: null,
  massInvitePendingNumbersCount: 0,
};

// Action constants
const GET_PHARMACY = 'GET_PHARMACY';
const GET_PHARMACY_SUCCESS = 'GET_PHARMACY_SUCCESS';
const GET_PHARMACY_FAILURE = 'GET_PHARMACY_FAILURE';

const CHECK_CSV_INVITE_FILE_EXISTENCE = 'CHECK_CSV_INVITE_FILE_EXISTENCE';
const CHECK_CSV_INVITE_FILE_EXISTENCE_SUCCESS = 'CHECK_CSV_INVITE_FILE_EXISTENCE_SUCCESS';
const CHECK_CSV_INVITE_FILE_EXISTENCE_FAILURE = 'CHECK_CSV_INVITE_FILE_EXISTENCE_FAILURE';

const RUN_MASS_INVITE = 'RUN_MASS_INVITE';
const RUN_MASS_INVITE_SUCCESS = 'RUN_MASS_INVITE_SUCCESS';
const RUN_MASS_INVITE_FAILURE = 'RUN_MASS_INVITE_FAILURE';

const GET_MASS_INVITE = 'GET_MASS_INVITE';
const GET_MASS_INVITE_SUCCESS = 'GET_MASS_INVITE_SUCCESS';
const GET_MASS_INVITE_FAILURE = 'GET_MASS_INVITE_FAILURE';

const CHECK_PENDING_MASS_INVITE = 'CHECK_PENDING_MASS_INVITE';
const CHECK_PENDING_MASS_INVITE_SUCCESS = 'CHECK_PENDING_MASS_INVITE_SUCCESS';
const CHECK_PENDING_MASS_INVITE_FAILURE = 'CHECK_PENDING_MASS_INVITE_FAILURE';

// Action creators
export const getPharmacy = pharmacyId => {
  return {
    types: [GET_PHARMACY, GET_PHARMACY_SUCCESS, GET_PHARMACY_FAILURE],
    payload: {
      request: {
        url: `/pharmacies/${pharmacyId}`,
        method: 'GET',
      }
    }
  };
};

export const checkCsvInviteFileExistence = pharmacyId => {
  return {
    types: [
      CHECK_CSV_INVITE_FILE_EXISTENCE,
      CHECK_CSV_INVITE_FILE_EXISTENCE_SUCCESS,
      CHECK_CSV_INVITE_FILE_EXISTENCE_FAILURE
    ],
    payload: {
      request: {
        url: `/pharmacies/${pharmacyId}/csv-exists`,
        method: 'GET',
      }
    }
  };
};

export const runMassInvite = pharmacyId => {
  return {
    types: [RUN_MASS_INVITE, RUN_MASS_INVITE_SUCCESS, RUN_MASS_INVITE_FAILURE],
    payload: {
      request: {
        url: `/pharmacies/${pharmacyId}/csv-invite`,
        method: 'POST',
      }
    }
  };
};

export const checkPendingMassInvite = (pharmacyId) => {
  return {
    types: [
      CHECK_PENDING_MASS_INVITE,
      CHECK_PENDING_MASS_INVITE_SUCCESS,
      CHECK_PENDING_MASS_INVITE_FAILURE,
    ],
    payload: {
      request: {
        url: `/pharmacies/${pharmacyId}/pending-mass-invite`,
        method: 'GET',
      },
    },
  };
}

export const getMassInviteStatus = (pharmacyId, massInviteId) => {
  return {
    types: [GET_MASS_INVITE, GET_MASS_INVITE_SUCCESS, GET_MASS_INVITE_FAILURE],
    payload: {
      request: {
        url: `/pharmacies/${pharmacyId}/mass-invite/${massInviteId}`,
        method: 'GET',
      },
    },
  };
}

const pharmacyReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_CSV_INVITE_FILE_EXISTENCE:
    case RUN_MASS_INVITE:
    case GET_PHARMACY:
      return {
        ...state,
        error: null,
        isLoading: true
      };

    case CHECK_CSV_INVITE_FILE_EXISTENCE_FAILURE:
    case RUN_MASS_INVITE_FAILURE:
    case GET_PHARMACY_FAILURE:
    case GET_MASS_INVITE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload?.data?.error || action.error?.response?.data?.error?.text,
      };

    case GET_PHARMACY_SUCCESS:
      return {
        ...state,
        pharmacy: action.payload.data.data && action.payload.data.data[0],
        isLoading: false
      };

    case CHECK_CSV_INVITE_FILE_EXISTENCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        csvExists: action.payload.data.data && action.payload.data.data[0].exists
      };

    case RUN_MASS_INVITE_SUCCESS:
      return {
        ...state,
        csvExists: false,
        isLoading: false,
        pendingMassInviteId: action.payload?.data?.data?.[0]?.mass_invite_id,
        massInvitePendingNumbersCount: action.payload?.data?.data?.[0]?.pending_telephone_numbers || 0,
      };

    case CHECK_PENDING_MASS_INVITE_SUCCESS:
      return {
        ...state,
        pendingMassInviteId: action.payload?.data?.data?.[0]?.mass_invite_id || null,
        massInvitePendingNumbersCount: action.payload?.data?.data?.[0]?.pending_telephone_numbers || 0,
      }

    case GET_MASS_INVITE_SUCCESS:
      return {
        ...state,
        ...(action.payload?.data?.data?.[0]?.finished
          ? { massInviteStats: action.payload?.data?.data?.[0], pendingMassInviteId: null }
          : { massInvitePendingNumbersCount: action.payload?.data?.data?.[0]?.pending_telephone_numbers || 0 } ),
      }

    default:
      return state;
  }
};

export default pharmacyReducer;
